import Chip from '@mui/material/Chip';
import type { AssetClass } from '../api/schemas';

export function AssetClassChip({ value }: { value: AssetClass }) {
  return <Chip label={value} variant="outlined" color={value === 'FX' || value === 'Rates' ? 'primary' : 'default'} />;
}
